import React from 'react';
import moment from 'moment';

const ICONS = {
  calendar: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  x: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  swap: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="17 1 21 5 17 9" />
      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
      <polyline points="7 23 3 19 7 15" />
      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
    </svg>
  ),
  card: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <line x1="2" y1="10" x2="22" y2="10" />
    </svg>
  ),
  heart: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  ),
  box: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
      <line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
  ),
};

const COLOUR_BY_TYPE = {
  booking_created: 'teal',
  booking_cancelled: 'red',
  booking_rescheduled: 'purple',
  payment_received: 'green',
  tip_received: 'brand',
  low_stock: 'amber',
  diary_shared: 'teal',
  diary_unshared: 'red',
};

const NotificationItem = ({ item, isUnread, index, onTap }) => {
  const colour = COLOUR_BY_TYPE[item.type] || 'neutral';
  const icon = ICONS[item.icon] || ICONS.calendar;
  const relative = moment(item.timestamp).fromNow();

  return (
    <button
      type="button"
      className={`notif-item notif-item--${colour} ${isUnread ? 'notif-item--unread' : ''}`}
      onClick={() => onTap(item)}
      style={{ animationDelay: `${Math.min(index, 10) * 30}ms` }}
    >
      <span className={`notif-icon notif-icon--${colour}`}>{icon}</span>
      <span className="notif-item-body">
        <span className="notif-title">{item.salonName ? `${item.salonName} · ` : ''}{item.title}</span>
        <span className="notif-subtitle">{item.subtitle}</span>
      </span>
      <span className="notif-meta">
        <span className="notif-time">{relative}</span>
        {isUnread && <span className="notif-dot" aria-hidden />}
      </span>
    </button>
  );
};

export default NotificationItem;
